const d3 = Object.assign({},
    require('d3-selection')
);

export class ChartRenderer {
    constructor ({ canvas }) {
        this.canvas = canvas;
    }

    getMainZone () {
        let main = this.canvas.container.select('.main');
        if (main.empty()) {
            main = this.canvas.container.append('g').attr('class', 'main');
        }
        return main;
    }

    addAxisLines (axisList) {
        let container = this.canvas.container.select('.axisLines');
        if (container.empty()) {
            container = this.canvas.container.append('g').attr('class', 'axisLines');
        }
        for (const [index, axis] of axisList.entries()) {
            let el = container.select(`.axis-${index}`);
            if (el.empty()) {
                el = container.append('g')
                    .attr('class', `axis-${index}`)
                    .attr('transform', `translate(${axis.xOffset}, ${axis.yOffset})`);
            }
            if (axis.rotated) {
                el.call(axis.line);
                el.selectAll('text')
                    .style('text-anchor', 'end')
                    .attr('dx', '-.8em')
                    .attr('dy', '.15em')
                    .attr('transform', 'rotate(-45)');
                if (axis.ellipsis) {
                    el.selectAll('text')
                        .attr('width', axis.ellipsis)
                        .each(this.setEllipsis);
                }
                if (axis.noOverlap) {
                    this.setNoOverlap(el);
                }
            } else {
                el.transition().call(axis.line);
            }
        }
    }

    addAxisLabels (cs, xAxisLabel, yAxisLabel) {
        const container = this.canvas.container;
        if (!xAxisLabel && !yAxisLabel) {
            return;
        }

        container.selectAll('text.axisLabel').remove();

        if (xAxisLabel) {
            container.append('text')
                .attr('font-size', '10')
                .attr('x', this.canvas.width / 2)
                .attr('y', this.canvas.height - 10)
                .attr('id', 'xAxisLabel')
                .attr('class', 'axisLabel')
                .style('text-anchor', 'middle')
                .text(xAxisLabel);
        }

        if (yAxisLabel) {
            container.append('text')
                .attr('font-size', '10')
                .attr('x', 10)
                .attr('y', this.canvas.height / 2)
                .attr('id', 'xAxisLabel')
                .attr('class', 'axisLabel')
                .style('text-anchor', 'middle')
                .text(yAxisLabel)
                .attr('transform', `rotate(-90,10, ${this.canvas.height / 2})`);
        }
    }

    setNoOverlap (d) {
        const textList = d.selectAll('text');
        const tickList = d.selectAll('.tick');
        const count = textList.size();
        if (count > 20) {
            let gap = Math.max(Math.round(count / 20), 2);
            textList.each(function (_d, idx) {
                if (idx % gap !== 0) {
                    d3.select(this).style('visibility', 'hidden');
                } else {
                    d3.select(this).style('visibility', 'visible');
                }
            });
            tickList.each(function (_d, idx) {
                if (idx % gap !== 0) {
                    d3.select(this).selectAll('line').attr('y2', 2);
                } else {
                    d3.select(this).selectAll('line').attr('y2', 6);
                }
            });
        } else {
            textList.each(function () {
                d3.select(this).style('visibility', 'visible');
            });
            tickList.each(function () {
                d3.select(this).selectAll('line').attr('y2', 6);
            });
        }
    }

    setEllipsis (d) {
        let self = d3.select(this);
        let textLength = self.node().getComputedTextLength();
        let text = self.text();

        self.text((d) => d);
        while ((textLength + 10) > self.attr('width') && text.length > 0) {
            text = text.slice(0, -1);
            self.text(text + '...');
            textLength = self.node().getComputedTextLength();
        }
    }
}
